import Grid2 from "@mui/material/Unstable_Grid2";
import { CustomAutocomplete } from "../../../../../components/custom/CustomAutocomplete";
import { Box, Typography } from "@mui/material";
import { LooksOne } from "@mui/icons-material";
import { COLORS } from "../../../../../ui/Theme";
import { useDomesticMarketSpreadPriceCategoryContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceCategoryContext";

const CommodityForm1 = () => {
  const {
    industries1,
    fields1,
    companies1,
    groups1,
    commodities1,
    inputCategoryValues1,
    setInputCategoryValues1,
  } = useDomesticMarketSpreadPriceCategoryContext();

  const { industry, field, company, group, commodity } = inputCategoryValues1;

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setInputCategoryValues1((prev) => ({
          ...prev,
          field: null,
          company: null,
          group: null,
          commodity: null,
        }));
      case "field":
        setInputCategoryValues1((prev) => ({
          ...prev,
          company: null,
          group: null,
          commodity: null,
        }));
      case "group":
        setInputCategoryValues1((prev) => ({
          ...prev,
          company: null,
          commodity: null,
        }));
        break;
      case "company":
        setInputCategoryValues1((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 0.5,
        }}
      >
        کالا
        <LooksOne sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={industries1.data}
            value={industry}
            onChange={(e, newValue) => {
              setInputCategoryValues1((prev) => ({
                ...prev,
                industry: newValue,
              }));
              clearForm("industry", newValue);
            }}
            isLoading={industries1.isLoading}
            placeholder="صنعت"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={fields1.data}
            value={field}
            onChange={(e, newValue) => {
              setInputCategoryValues1((prev) => ({
                ...prev,
                field: newValue,
              }));
              clearForm("field", newValue);
            }}
            isLoading={fields1.isLoading}
            placeholder="زمینه"
          />
        </Grid2>

        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={groups1.data}
            value={group}
            onChange={(e, newValue) => {
              setInputCategoryValues1((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups1.isLoading}
            placeholder="گروه (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={companies1.data}
            value={company}
            onChange={(e, newValue) => {
              setInputCategoryValues1((prev) => ({
                ...prev,
                company: newValue,
              }));
              clearForm("company", newValue);
            }}
            isLoading={companies1.isLoading}
            placeholder="شرکت (اختیاری)"
          />
        </Grid2>
        <Grid2 xs={12} lg={2.4}>
          <CustomAutocomplete
            options={commodities1.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputCategoryValues1((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities1.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default CommodityForm1;
